module.exports = __webpack_public_path__ + "static/media/pokedex_sc.6ec4e6fc.png";